import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {EingabeForm} from './eingabe.form';
import {Step, StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {WpcheckRequestService} from '../services/request.service';
import {WpcheckAnfrage} from '../anfrage/wpcheck.anfrage';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';

/**
 * Overwrite the Generic step component for the first section fo the wpcheck.
 *
 * @inheritDoc
 */
@Component({
  selector: 'app-step-eingabe',
  templateUrl: '../../step/step.component.html'
})
export class EingabeStepComponent extends StepComponent implements OnInit {

  /**
   * (input) data of the user
   */
  anfrage: WpcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * Overwrite the label prefix.
   */
  textkeyPrefix = 'wpcheck';

  hideHelpForSteps = [];

  /**
   * Holds the previous step object to move back.
   */
  previousStep: Step;

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: WpcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.anfrage = this.anfrage;

    this.formConfig.setStepComponent(this);
    this.formConfig.setData(this.anfrage.userInput);

    if (this.steps.currentStep && this.hideHelpForSteps.includes(this.steps.currentStep.name)) {
      this.hideHelp();
    }

    // update the previous step
    this.onStepUpdate();

    if (this.steps.currentStep && this.steps.currentStep.name === 'massnahmen/5') {
      this.steps.nextStep = new Step('ergebnis/analyse', '/wpcheck/ergebnis/analyse');
    }
  }

  /**
   * @inheritDoc
   */
  saveData(data: { [key: string]: any }) {
    // merge the data with the existing data
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};
    this.requestService.setAnfrage(this.anfrage);

    // save the data also to the server
    this.requestService.saveDataToServer();

    super.saveData(data);
  }

  /**
   * moveon to the next step in the routing
   */
  moveToNextStep(): void {
    if (this.steps.currentStep && this.steps.currentStep.name === 'massnahmen/5') {
      this.router.navigateByUrl(this.portalService.currentPortalId + '/wpcheck/ergebnis/analyse');
    }
    else {
      super.moveToNextStep();
    }
  }

  /**
   * Return the next step from a step list
   */
  getNextStepFromList(stepList: Step[]): any {
    // set all data again in the form to avoid using old data for toggle fields
    if (this.anfrage?.userInput && this.formConfig) {
      this.formConfig.updateFields(this.anfrage.userInput);
      // save the data again. In some case some fields are auto updated
      this.saveData({});
    }

    return super.getNextStepFromList(stepList);
  }

  /**
   * @inheritDoc
   */
  onStepUpdate() {
    super.onStepUpdate();

    // set previous step to intro page
    if (this.steps?.currentStep && this.steps?.currentStep?.name === 'basisinformationen/1') {
      this.previousStep = new Step('start', '../../../start');
    }

    // change the pagehelptext for some cases here
    if (this.steps.currentStep.name === 'massnahmen/3' && !(this.anfrage?.userInput?.gebaeude_dachform === 'spitzdach' &&
      this.anfrage?.userInput?.gebaeude_dachausbau === 'nein')) {
      this.helpTextkey += '.dach';
    }
  }

  /**
   * @inheritDoc
   */
  onSubmit() {
    /* some inputs end the advisor */
    if (this.isAdvisorEnd()) {
      // save data
      this.saveData(this.formConfig.getData());

      // navigate to end page
      this.router.navigateByUrl(this.portalService.currentPortalId + '/wpcheck/eingabe/ausstieg', {state: {lastStep: this.router.url}});
      return;
    }

    super.onSubmit();

    if (this.form.valid === false) {
      // form is not valid, maybe form errors are shown. Scroll upwards
      this.elementService.scrollToElement(this.stepForm.nativeElement);
    }
  }

  /**
   * In some cases the advisor has to stop because we cannot offer any advice for this user/building
   * Hint: new cases have to be added also to VerbrauchsanalyseAusstiegComponent
   */
  isAdvisorEnd(): boolean {
    // not central heating
    if (this.form.get('heizungstyp') &&
      (
        this.form.get('heizungstyp')?.value === 'dezentral' ||
        (this.form.get('heizungstyp')?.value === 'dezentral2' && this.anfrage?.userInput?.gebaeudetyp === 'mehrfamilienhaus')
      )
    ) {
      return true;
    }

    // mieter
    if (this.form.get('nutzungstyp') && this.form.get('nutzungstyp')?.value === 'mieter') {
      return true;
    }

    // denkmalschuz
    if (this.form.get('gebaeude_denkmalschutz') && this.form.get('gebaeude_denkmalschutz')?.value === 'ja') {
      return true;
    }

    return false;
  }
}
